import {
  BrandName,
  SupportedCountryCode
} from '@seek/je-shared-data/lib/types/brand';

// The coins BFF router was decommissioned along with je-client. This hook is
// retained as an inert stub so obsolete coins UI still compiles; it no longer
// fetches coin pricing.
export type QueryOptions = {
  enabled?: boolean;
};

type Params = {
  jobCountryCode: SupportedCountryCode;
  brand: BrandName;
};

export type ErrorResponse = null;

export const useFetchCoinPricing = (
  _params: Params,
  _queryOptions?: QueryOptions
) => {
  return {
    data: undefined as any,
    isError: false,
    error: null as ErrorResponse,
    isLoading: false
  };
};
